'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;

var _capeLodash = require('cape-lodash');

var _actions = require('./actions');

var defaultState = {
  title: 'Default Title'
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.REPLACE_DB:
      return action.payload;

    case _actions.UPDATE_TITLE:
      return (0, _capeLodash.setKey)('title', state, action.payload);

    case _actions.UPDATE_PROP:
      return (0, _capeLodash.setIn)(action.payload.path, state, action.payload.value);

    default:
      return state;
  }
}